/* NOMO 03-10 product page update.
   1. Bundle names on the 1/2/4 cards (Essential, Duo, Family).
   2. Swipe cues under the photo and video rails: hint, progress bar and one gentle nudge. */
(() => {
  // Every text comes from the "Teksten productpagina" section (theme editor); empty = default.
  let T = {};
  try { T = JSON.parse(document.getElementById('nomo-hero-texts')?.textContent || '{}'); } catch (_) {}
  const txt = (key, fallback) => (T[key] && String(T[key]).trim()) || fallback;
  const names = txt('bundleNames', 'Essential | Duo | Family').split('|').map(s => s.trim());
  const BUNDLE_NAMES = { 1: names[0] || 'Essential', 2: names[1] || 'Duo', 4: names[2] || 'Family' };
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 0. Hero: title (editable), placed under the proof line; proof line text; headline
  document.querySelectorAll('nomo-product .nomo-smooth-name').forEach(name => {
    const parts = txt('title', 'NOMO | Keychain Tote').split('|');
    name.textContent = '';
    parts.forEach((part, i) => {
      if (i) { const bar = document.createElement('span'); bar.className = 'nb-hero-title__bar'; bar.setAttribute('aria-hidden', 'true'); bar.textContent = '|'; name.append(bar); }
      name.append(document.createTextNode(part.trim()));
    });
    const proof = name.parentElement.querySelector('.nomo-proof');
    if (proof) proof.after(name);
  });
  document.querySelectorAll('nomo-product .nomo-proof__text').forEach(el => {
    const strong = el.querySelector('strong'), check = el.querySelector('svg');
    const name = txt('proofName', 'Linda'), rest = txt('proofText', 'en 10.000+ anderen kochten');
    el.textContent = '';
    if (name) { if (strong) { strong.textContent = name; el.append(strong); } else { const s = document.createElement('strong'); s.textContent = name; el.append(s); } if (check) el.append(check); el.append(' '); }
    el.append(rest);
  });
  document.querySelectorAll('nomo-product .nb-hero-box .product-title').forEach(h => { h.textContent = txt('headline', 'Nooit meer zonder tas.'); });
  if (T.usps && T.usps.trim()) document.querySelectorAll('nomo-product .nb-hero-box .product-subtitle').forEach(sub => { sub.textContent = T.usps.split(/\r?\n/).map(s => s.trim()).filter(Boolean).join(' · '); });
  document.querySelectorAll('.nb-bundle legend').forEach(l => { l.textContent = txt('bundleLegend', 'Hoeveel tassen?'); });
  document.querySelectorAll('.nb-clips__title').forEach(h => { h.textContent = txt('clipsHeading', h.textContent); });
  // Delivery & returns accordion: two paragraphs, no policy links
  document.querySelectorAll('.nomo-purchase-details details').forEach(d => {
    const title = d.querySelector('.nb-acc__title')?.textContent || '';
    if (!/verzend/i.test(title)) return;
    const body = d.querySelector(':scope > div'); if (!body) return;
    body.textContent = '';
    [txt('deliveryReturns', 'Niet tevreden? Stuur ons een mailtje en retourneer je NOMO binnen 30 dagen naar ons fulfilmentcenter in Nederland. Geen gedoe met internationale verzending.'),
     txt('deliveryShipping', 'Gratis verzending tijdens onze herfstsale. Bestel je op een werkdag vóór 17:00, dan verzenden we dezelfde dag met PostNL of DHL, afhankelijk van je adres. Let op: in drukke periodes kan de levertijd bij PostNL oplopen.')
    ].forEach(t => { const p = document.createElement('p'); p.textContent = t; body.append(p); });
  });
  // The three USPs under the headline: the subtitle text, split on " · ", becomes a list.
  document.querySelectorAll('nomo-product .nb-hero-box .product-subtitle').forEach(sub => {
    const parts = sub.textContent.split(' · ').map(part => part.trim()).filter(Boolean);
    if (parts.length < 2) return;
    const list = document.createElement('ul');
    list.className = 'nb-hero-usps';
    list.setAttribute('role', 'list');
    parts.forEach(part => { const li = document.createElement('li'); li.textContent = part; list.appendChild(li); });
    sub.replaceChildren(list);
  });

  // 1. Bundle names
  document.querySelectorAll('[data-bundle-card]').forEach(card => {
    if (card.dataset.nbNamed) return;
    const count = Number(card.querySelector('[data-quantity-choice]')?.value);
    const label = card.querySelector('.nb-bundle__body > b');
    if (!BUNDLE_NAMES[count] || !label) return;
    card.dataset.nbNamed = '1';
    const amount = document.createElement('span');
    amount.className = 'nb-bundle__count';
    amount.textContent = label.textContent.trim();
    label.textContent = BUNDLE_NAMES[count];
    label.classList.add('nb-bundle__name');
    label.after(amount);
  });

  // 3. Gallery: every colour starts with its own tote packshot, then its keychain photo; the videos and steps follow.
  const Proto = customElements.get('nomo-product')?.prototype;
  if (Proto && !Proto.__nbGallery) {
    Proto.__nbGallery = true;
    const original = Proto.updateGalleryForVariant;
    Proto.updateGalleryForVariant = function (size, color, preferred) {
      original.call(this, size, color, preferred);
      const section = this.closest('.product-hero');
      const items = this.galleryItems || [];
      if (!section || !items.length) return;
      const s = String(size || '').toLowerCase(), c = String(color || '').toLowerCase();
      const all = [...section.querySelectorAll('[data-gallery-item]')];
      const src = el => el.querySelector('img')?.getAttribute('src') || '';
      const packshot = all.find(el => /^\d+$/.test(el.dataset.mediaId) && el.dataset.gallerySize === s && el.dataset.galleryColor === c && !/lifestyle/.test(src(el)));
      const keychain = all.find(el => el.dataset.mediaId.startsWith('nomo-keychain') && el.dataset.galleryColor === c && (!el.dataset.gallerySize || el.dataset.gallerySize === s));
      const lead = [packshot, keychain].filter(Boolean);
      if (!lead.length) return;
      this.galleryItems = [...lead, ...items.filter(el => !lead.includes(el))];
      const thumbWrap = section.querySelector('.gallery-thumbs');
      this.galleryItems.forEach(el => {
        const thumb = thumbWrap?.querySelector('[data-gallery-thumb][data-media-id="' + CSS.escape(el.dataset.mediaId) + '"]');
        if (thumb) { thumb.hidden = false; thumbWrap.appendChild(thumb); }
      });
      this.selectMedia(this.galleryItems[0].dataset.mediaId);
    };
    document.querySelectorAll('nomo-product').forEach(el => { if (el.galleryItems) el.updateGalleryForVariant(el.dataset.selectedSize || 'small', el.dataset.selectedColor || 'black'); });
  }

  // 2. Swipe cues
  const setupRail = track => {
    if (track.dataset.nbMeta) return;
    track.dataset.nbMeta = '1';
    const items = () => [...track.children].filter(child => child.offsetWidth);
    const meta = document.createElement('div');
    meta.className = 'nb-rail-meta';
    meta.innerHTML = '<span class="nb-rail-meta__hint" aria-hidden="true">' + txt('swipeHint', 'Swipe voor meer') + ' <svg viewBox="0 0 24 24"><path d="M5 12h13M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span class="nb-rail-meta__bar" aria-hidden="true"><i></i></span>';
    (track.closest('.nb-chev-host') || track).after(meta);
    const bar = meta.querySelector('i');
    const sync = () => {
      const list = items();
      if (!list.length) return;
      const max = Math.max(1, track.scrollWidth - track.clientWidth);
      const progress = Math.min(1, Math.max(0, track.scrollLeft / max));
      bar.style.width = Math.max(100 / list.length, progress * 100) + '%';
      meta.classList.toggle('is-moved', track.scrollLeft > 8);
      meta.hidden = track.scrollWidth <= track.clientWidth + 4;
    };
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
    sync();
    // One gentle nudge the first time the rail is on screen, so it is clear there is more.
    if (reduced || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      io.disconnect();
      window.setTimeout(() => {
        if (track.scrollLeft > 8 || track.scrollWidth <= track.clientWidth + 4) return;
        items().forEach(child => child.animate?.([{ transform: 'translateX(0)' }, { transform: 'translateX(-56px)' }, { transform: 'translateX(0)' }], { duration: 1100, easing: 'cubic-bezier(.45,0,.2,1)' }));
      }, 450);
    }, { threshold: .6 });
    io.observe(track);
  };
  // theme.js wraps rails for its chevrons first; run after it.
  const init = () => document.querySelectorAll('.nomo-community__track,.nb-clips__rail').forEach(setupRail);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
